
















import Vue from 'vue'

export default Vue.extend({
  props: ['title', 'width', 'visible'],
  data() {
    return {
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    }
  }
})
